import React, { useEffect, useState } from 'react';
import ReactJson from 'react-json-view';
import { Row, Col, Input, Button, FormGroup } from 'reactstrap';
import { apiClientEosNative } from '../../../apiClient';
import MawbInput from '../../../components/custom/MawbInput';


export default function UnitedGetAwb () {

    const [awb, setAwb] = useState('');
    const [json, setJson] = useState({});

    const handleSearch = async() => {
        try {
            const res = await apiClientEosNative.get(`/breakdown-by-flight/united-awb/${awb}`);
            setJson(res.data);
        } catch (err) {
            alert(err);
        }
    };

    return (
        <Row>
            <Col md={12}>
                <FormGroup className={'d-flex'}>
                    <MawbInput 
                        value={awb}
                        onChange={setAwb}
                    />
                    <Button className={'ml-2'} onClick={() => handleSearch()}>Search</Button>
                </FormGroup>
                <h4>Results:</h4>
                {
                    Object.keys(json).length > 0 && 
                    <ReactJson src={json} displayDataTypes={false} />
                }
            </Col>
        </Row>
    );
}